import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import ScenarioSelectionChartsLayout from './ScenarioSelectionChartsLayout';
import ScenarioSelectionChartsMetaOverride from './ScenarioSelectionChartsMetaOverride';

const ScenarioSelectionCharts = ({ relationship }) => {
  const { collection, loading, loadingError } = useLink(relationship.link('related'));

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection,
        layout: ScenarioSelectionChartsLayout,
        metaOverrideSet: ScenarioSelectionChartsMetaOverride,
      }}
      loading={loading}
      loadingError={loadingError}
    />
  );
};

ScenarioSelectionCharts.propTypes = {
  relationship: PropTypes.object.isRequired,
};
ScenarioSelectionCharts.defaultProps = {};

export default ScenarioSelectionCharts;
